import React, { useEffect, useImperativeHandle } from "react"
import { useDispatch, useSelector } from "react-redux"
import MatrixItemsListingSection from "./MatrixItemsListingSection"
import MatrixAxisSection from "./MatrixAxisSection"
import { clear, provision } from "../../../state/product/ProductActions"
import { Intl } from "../../../state/helpers/IntlProps"
import { getMatrixAttributes, getMatrixItemsLength } from "../../../state/product/ProductSelectors"
import { MatrixRequestDto, NewMatrixRequestDto } from "../../../state/product/matrix/MatrixDto"
import { ProductDto } from "../../../state/product/Product"

type Props = {
    intl: Intl
    product?: ProductDto
    onSave: () => void
    isFormDirty: boolean
}

const MatrixEditSectionWrapper = (props: Props, ref) => {

    const dispatch = useDispatch()
    const matrix = useSelector(getMatrixAttributes)
    const matrixItemsLength = useSelector(getMatrixItemsLength)

    useEffect(() => {
        if (props.product) {
            dispatch(provision(props.product.attributes))
        } else {
            dispatch(clear())
        }
    }, [])

    useImperativeHandle(ref, () => ({
        didUpdate: (): boolean => {
            return matrix.didUpdate_
        },
        getPayload: (): MatrixRequestDto => {
            return NewMatrixRequestDto(matrix)
        },
        getItemsLength: (): number => {
            return matrixItemsLength
        }
    }))

    return (
        <div>
            <MatrixAxisSection />
            <MatrixItemsListingSection
                parentId={props.product?.id}
                isFormDirty={props.isFormDirty}
                isMatrixDirty={!!matrix.didUpdate_}
                onSave={props.onSave}
            />
        </div>
    )
}

export default React.forwardRef(MatrixEditSectionWrapper)


// WEBPACK FOOTER //
// ./src/product/variant/section/MatrixEditSectionWrapper.tsx